import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import * as components from "vuetify/lib/components";
import * as directives from "vuetify/lib/directives";
import "vuetify/dist/vuetify.min.css";
import brandConfig from "@/config/brandConfig";

Vue.use(Vuetify, {
  components,
  directives,
});

export default new Vuetify({
  icons: {
    iconfont: "mdi" || "fa",
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: brandConfig.colors.primary.default,
        primaryDark: brandConfig.colors.primary.dark,
        primaryLight: brandConfig.colors.primary.light,
        // Add more theme colors as you define them
        // secondary: brandConfig.colors.secondary.default,
        // secondaryDark: brandConfig.colors.secondary.dark,
        // secondaryLight: brandConfig.colors.secondary.light,
      },
      dark: {
        primary: brandConfig.colors.primary.default,
        primaryDark: brandConfig.colors.primary.dark,
        primaryLight: brandConfig.colors.primary.light,
        // Add dark theme specific colors here
      },
    },
  },
});
